import type { ReactNode } from 'react'
import { cn } from '@quebon/ui/lib/utils'
import { coachingOperationAppearance, type CoachingOperationKind } from './coachingOperationAppearance'

interface Props {
  kind: CoachingOperationKind
  title: string
  description?: string
  actions?: ReactNode
  children: ReactNode
  bodyClassName?: string
}

export function CoachingOperationPanel({ kind, title, description, actions, children, bodyClassName }: Props) {
  const { Icon, surface, border, iconBackground } = coachingOperationAppearance[kind]
  return (
    <section aria-label={title} className={cn('min-w-0 rounded-xl border p-4 shadow-sm', surface, border)}>
      <header className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <span aria-hidden="true" className={cn('grid size-9 shrink-0 place-items-center rounded-xl text-primary-foreground', iconBackground)}>
            <Icon className="size-[18px]" />
          </span>
          <div className="flex min-w-0 flex-col gap-1">
            <h3 className="break-words text-sm font-bold text-foreground">{title}</h3>
            {description ? <p className="text-xs leading-relaxed text-muted-foreground">{description}</p> : null}
          </div>
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </header>
      <div className={cn('min-w-0 rounded-lg border border-border bg-card', bodyClassName)}>{children}</div>
    </section>
  )
}
